/**
 * 与 FUtil.Domain.getEnvSuffix().replace(/^\./, '') 一致（prod/dev/test）。
 * MF 等场景下共享的 FUtil 可能未挂载 Domain，版权文案用本函数避免运行时崩溃。
 */
export function wwwFooterCopyrightDomainLabel(): string {
  if (typeof window === 'undefined') {
    return 'freelog.cn';
  }
  const { origin } = window.location;
  if (origin.includes('.freelog.cn')) {
    return 'freelog.cn';
  }
  if (origin.includes('.devfreelog.com')) {
    return 'devfreelog.com';
  }
  return 'testfreelog.com';
}
